import React, { PropsWithChildren, forwardRef } from 'react';
import * as S from './Button.styles';
import { Spinner } from '@/components/Spinner/Spinner';
import { ButtonProps } from '@/components/UI/Button/Button.types';

export const Button = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<ButtonProps>
>(
  (
    {
      children,
      shape,
      appearance,
      size = 'm',
      isFullWidth,
      isAutoWidth,
      hasPadding = true,
      isLoading,
      borderRadius,
      height,
      isBodyFontFamily,
      ...props
    },
    ref
  ) => {
    return (
      <S.ButtonBox
        ref={ref}
        {...props}
        type={props.type ?? 'button'}
        $shape={shape}
        $appearance={appearance}
        $size={size}
        $isFullWidth={isFullWidth}
        $isAutoWidth={isAutoWidth}
        $hasPadding={hasPadding}
        $isLoading={isLoading}
        $borderRadius={borderRadius}
        $height={height}
        $isBodyFontFamily={isBodyFontFamily}
      >
        {isLoading ? <Spinner /> : children}
      </S.ButtonBox>
    );
  }
);

Button.displayName = 'Button';
